/* 
FrFr FRIENDLY FRAMEWORK
web storage utils
Version 0a 2019-07-05
by 
// Please describe here if you customized this file
*/

let local_storage_utils = {};
let session_storage_utils = {};


// local storage

local_storage_utils.item_get = async (key) => {
  let value = await window.localStorage.getItem(key); // read from local storage
  // console.log('WE HAVE DATA FOR ' + key + ': ' + value);
  // return { key, value }
  return value;
};

local_storage_utils.item_set = async (key, value) => {
  await window.localStorage.setItem(key, value); // write to local storage
  // await AsyncStorage.setItem(key, value.toString());
};

local_storage_utils.item_delete = async (key) => {
  // await window.localStorage.removeItem(key); // delete from localstorage
  let value = await window.localStorage.removeItem(key); // delete from localstorage
  return true;
};

local_storage_utils.all_items_key_list = async (key) => {
  let keys = Object.keys(window.localStorage);
  return keys;
};

local_storage_utils.all_items_key_value_list = async (key) => {
  let list = [];
  let keys = Object.keys(window.localStorage);
  let i = keys.length;
  while (i--) {
    list.push([keys[i], window.localStorage[keys[i]]]);
  }
  return list; // output is [[key,value],[key,value],...]
};


// session storage

session_storage_utils.item_get = async (key) => {
  let value = await window.sessionStorage.getItem(key);
  // console.log('WE HAVE DATA FOR ' + key + ': ' + value);
  // return { key, value }
  return value;
};

session_storage_utils.item_set = async (key, value) => {
  await window.sessionStorage.setItem(key, value);
  // await AsyncStorage.setItem(key, value.toString());
};

session_storage_utils.item_delete = async (key) => {
  let value = window.sessionStorage.removeItem(key); // delete from localstorage
  return true;
};

export { local_storage_utils, session_storage_utils };